/* STOQ y Smile dentro del tema · SOP-apps-integradas.md
   Tres piezas y ninguna ventana:
     1. <aud-aviso>  — la tarjeta «Te avisamos cuando vuelva», con el formulario de STOQ en línea.
     2. <aud-pesos>  — «Con esta bota ganas $X en puntos Audor».
     3. <aud-cj-pesos> — la misma cuenta en el carrito, sobre el total con descuentos.
   Todo lo inyectado lleva etiqueta propia: un `div` se lo queda el morph de Horizon (D-061). */

(() => {
  const CFG = (window.audApps && window.audApps.pesos) || {};

  /* $144.900 — con el formato de la TIENDA (`shop.money_format`, que llega en `audApps.formato`),
     no con uno fijo: el 2026-10-01 Fredie pasó la tienda a punto de miles y esta cifra se quedó
     con coma al lado de precios con punto. Es el mismo formateador de `aud-carrito.js` y
     `aud-escalones.js`. Se redondea al peso antes de escribir, como siempre: el 5 % de un precio
     puede dar medio peso. Sin formato a la vista, cae al de antes. */
  const FORMATO = (window.audApps && window.audApps.formato) || '${{amount_no_decimals}}';

  const separar = (centavos, mil, dec, conDecimales) => {
    const v = Math.abs(Math.round(centavos));
    const entero = String(Math.floor(v / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, mil);
    return entero + (conDecimales ? dec + String(v % 100).padStart(2, '0') : '');
  };

  const pesos = (centavos) => {
    const c = Math.round(centavos / 100) * 100;
    return String(FORMATO).replace(/\{\{\s*(\w+)\s*\}\}/g, (_, clave) => {
      switch (clave) {
        case 'amount': return separar(c, ',', '.', true);
        case 'amount_no_decimals': return separar(c, ',', '.', false);
        case 'amount_with_comma_separator': return separar(c, '.', ',', true);
        case 'amount_no_decimals_with_comma_separator': return separar(c, '.', ',', false);
        case 'amount_with_apostrophe_separator': return separar(c, "'", '.', true);
        case 'amount_with_space_separator': return separar(c, ' ', ',', true);
        case 'amount_no_decimals_with_space_separator': return separar(c, ' ', ',', false);
        default: return '';
      }
    });
  };

  /* La variante elegida en ESTA ficha: el `name="id"` del formulario de compra de la misma
     sección. Si no aparece, el `?variant=` de la dirección; si tampoco, la inicial. */
  const varianteDe = (nodo, inicial) => {
    const seccion = nodo.closest('.shopify-section') || document;
    const campo = seccion.querySelector('form[action*="/cart/add"] [name="id"]');
    const url = new URL(location.href).searchParams.get('variant');
    return String((campo && campo.value) || url || inicial || '');
  };

  const leerJSON = (nodo, sel) => {
    try {
      return JSON.parse(nodo.querySelector(sel).textContent);
    } catch (e) {
      return null;
    }
  };

  /* Cambiar de talla NO cambia el `name="id"` en el acto: Horizon pide la sección a la red y
     REEMPLAZA el formulario al volver (medido el 30-sep: el `change` llega antes que la
     variante nueva). Por eso tras cada `change` se revisa varias veces, y además se vigila la
     sección por nodos reemplazados. `pintar` no toca nada si nada cambió, así que el vigilante
     no se despierta a sí mismo. */
  const alCambiarVariante = (nodo, fn) => {
    let espera;
    const pronto = () => {
      clearTimeout(espera);
      espera = setTimeout(fn, 120);
    };
    document.addEventListener('change', () => [80, 400, 1000, 2000].forEach((ms) => setTimeout(fn, ms)));
    const seccion = nodo.closest('.shopify-section');
    if (seccion) {
      new MutationObserver(pronto).observe(seccion, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['value'],
      });
    }
    window.addEventListener('popstate', pronto);
  };

  const ponerTexto = (nodo, texto) => {
    if (nodo.textContent !== texto) nodo.textContent = texto;
  };

  /* ---------------------------------------------------------------- 1 · STOQ */

  /* STOQ carga tarde y por su cuenta. Se espera hasta 15 s; si no llega, la tarjeta no sale y
     queda el botón propio de la app. */
  const esperarStoq = () =>
    new Promise((ok) => {
      let n = 0;
      const t = setInterval(() => {
        if (window._Stoq && typeof window._Stoq.openInlineForm === 'function') {
          clearInterval(t);
          ok(window._Stoq);
        } else if (++n > 50) {
          clearInterval(t);
          ok(null);
        }
      }, 300);
    });

  class AudAviso extends HTMLElement {
    connectedCallback() {
      this.mapa = leerJSON(this, '[data-aud-aviso-mapa]');
      if (!this.mapa) return;
      this.seccion = this.closest('.shopify-section') || document.body;
      this.formulario = this.querySelector('aud-aviso-form');
      this.abierta = '';
      if (!this.vigilando) {
        this.vigilando = true;
        alCambiarVariante(this, () => this.pintar());
      }
      esperarStoq().then((stoq) => {
        this.stoq = stoq;
        this.pintar();
      });
    }

    pintar() {
      if (!this.stoq || !this.isConnected) return;
      const id = varianteDe(this, this.mapa.inicial);
      const v = this.mapa.v[id];
      const agotada = !!v && v.a === false;

      if (this.hidden === agotada) this.hidden = !agotada;
      if (agotada) {
        const modo = this.dataset.ocultarAgotado === 'true' ? 'ocultar' : 'si';
        if (this.seccion.getAttribute('data-aud-aviso') !== modo) this.seccion.setAttribute('data-aud-aviso', modo);
        this.querySelectorAll('[data-aud-aviso-talla]').forEach((b) => ponerTexto(b, v.t));
        /* STOQ vuelve a pintar su formulario si cambió la talla o si el morph se lo llevó. */
        const vacio = !this.formulario.querySelector('#restock-rocket-inline-container');
        if (this.abierta !== id || vacio) {
          this.abierta = id;
          this.stoq.openInlineForm(null, Number(id), null, '#' + this.formulario.id, 'beforeend');
        }
      } else {
        if (this.seccion.hasAttribute('data-aud-aviso')) this.seccion.removeAttribute('data-aud-aviso');
        this.abierta = '';
      }
    }
  }

  /* ---------------------------------------------------------------- 2 · Pesos en la ficha */

  class AudPesos extends HTMLElement {
    connectedCallback() {
      this.precios = leerJSON(this, '[data-aud-pesos-precios]');
      if (!this.precios || !CFG.activo || !CFG.pct) return;
      this.querySelectorAll('[data-aud-pesos-nombre]').forEach((n) => ponerTexto(n, CFG.nombre));
      if (!this.vigilando) {
        this.vigilando = true;
        alCambiarVariante(this, () => this.pintar());
      }
      this.pintar();
    }

    pintar() {
      const precio = this.precios.v[varianteDe(this, this.precios.inicial)];
      if (!precio) return;
      this.querySelectorAll('[data-aud-pesos-monto]').forEach((m) => ponerTexto(m, pesos((precio * CFG.pct) / 100)));
      if (this.hidden) this.hidden = false;
    }
  }

  /* ---------------------------------------------------------------- 3 · Pesos en el carrito */

  class AudCjPesos extends HTMLElement {}

  const plantillaCarrito = () => {
    const t = String(CFG.carrito || '').trim();
    if (!t || !CFG.activo || !CFG.pct) return null;
    return t
      .replace('[nombre]', '<span class="aud-cj-pesos__nombre"></span>')
      .replace('[monto]', '<b class="aud-cj-pesos__monto"></b>');
  };

  let total = null;
  /* El carrito lo lee `aud-carrito.js` y lo comparte en `window.AudCarrito.leer()` (SOP-velocidad
     §5.3): una lectura por ráfaga para toda la página. Solo si ese módulo no está, se pide aquí.
     `fuerza` va en los eventos de carrito (cambió de verdad); en el observador no. */
  const leerCarrito = async (fuerza) => {
    try {
      const lector = window.AudCarrito && window.AudCarrito.leer;
      const c = lector
        ? await lector(fuerza === true)
        : await fetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
      total = c.item_count > 0 ? c.total_price : 0;
    } catch (e) {
      /* sin carrito legible no se promete nada */
      total = null;
    }
    ponerEnCarrito();
  };

  const ponerEnCarrito = () => {
    const html = plantillaCarrito();
    document.querySelectorAll('.cart-totals').forEach((caja) => {
      let linea = caja.querySelector('aud-cj-pesos');
      if (!html || !total) {
        if (linea) linea.remove();
        return;
      }
      if (!linea) {
        linea = document.createElement('aud-cj-pesos');
        linea.className = 'aud-cj-pesos';
        const p = document.createElement('p');
        p.innerHTML = html;
        linea.appendChild(p);
        caja.appendChild(linea);
      }
      const n = linea.querySelector('.aud-cj-pesos__nombre');
      if (n) ponerTexto(n, CFG.nombre);
      const m = linea.querySelector('.aud-cj-pesos__monto');
      if (m) ponerTexto(m, pesos((total * CFG.pct) / 100));
    });
  };

  /* El total cambia al sumar, restar o aplicar un código. Se escucha el evento estándar del
     carrito y, como red, se vigila el cajón: Horizon lo vuelve a pintar entero. */
  const vigilarCarrito = async () => {
    if (!plantillaCarrito()) return;
    try {
      const SE = await import('@shopify/events');
      if (SE && SE.StandardEvents && SE.StandardEvents.cartLinesUpdate) {
        document.addEventListener(SE.StandardEvents.cartLinesUpdate, (ev) => {
          const fresca = () => leerCarrito(true);
          (ev.promise || Promise.resolve()).then(fresca, fresca);
        });
      }
    } catch (e) {
      /* sin el módulo, basta el observador */
    }
    let espera;
    new MutationObserver(() => {
      if (document.querySelector('.cart-totals:not(:has(aud-cj-pesos))')) {
        clearTimeout(espera);
        espera = setTimeout(leerCarrito, 150);
      }
    }).observe(document.body, { childList: true, subtree: true });
    leerCarrito();
  };

  if (!customElements.get('aud-aviso')) customElements.define('aud-aviso', AudAviso);
  if (!customElements.get('aud-pesos')) customElements.define('aud-pesos', AudPesos);
  if (!customElements.get('aud-cj-pesos')) customElements.define('aud-cj-pesos', AudCjPesos);
  vigilarCarrito();
})();
